<template>
  <details-view
    v-if="!loading"
    v-bind:session="session"
    v-bind:go_to_details="goToDetails"
    v-bind:fetch_session="fetchSession" />
  <spinner
    sizes="w-20 h-20"
    v-else
    thickness="border-8" />
</template>

<script>
  import spinner from '@/components/utils/spinner';
  import { API } from '@/http-common';
  import detailsView from '@/views/_espace/_refonte/formateur/_sessions-details/details.vue';
  export default {
    components: {
      detailsView,
      spinner
    },
    props: {},
    data() {
      return {
        loading: false,
        session: {},
        s: 'sessionsdone'
      };
    },
    computed: {
      session_reference() {
        return this.$route.query.reference;
      },
      active_tab() {
        return this.$route.query.tab;
      }
    },
    watch: {
      async session_reference() {
        // Nécessaire dans un sous produit de parcours
        await this.fetchSession();
      }
    },
    async created() {
      await this.fetchSession();
    },
    methods: {
      async fetchSession() {
        this.loading = true;
        const response = await API.get(
          `formateur/session/${this.session_reference}/details`,
          this.$header_skip_redirection
        );

        if (response && response.data) {
          this.session = response.data;
        }
        this.loading = false;
      },
      goToDetails(reference) {
        if (reference) {
          this.$router.push({
            path: '/formateur/sessions-details',
            query: {
              reference,
              tab: this.active_tab
            }
          });
        }
      }
    }
  };
</script>
